/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CurrentUserDetail } from './CurrentUserDetail';
import {
    CurrentUserDetailFromJSON,
    CurrentUserDetailFromJSONTyped,
    CurrentUserDetailToJSON,
} from './CurrentUserDetail';

/**
 * 
 * @export
 * @interface GetCurrentUser200Response
 */
export interface GetCurrentUser200Response {
    /**
     * 
     * @type {CurrentUserDetail}
     * @memberof GetCurrentUser200Response
     */
    data?: CurrentUserDetail;
}

/**
 * Check if a given object implements the GetCurrentUser200Response interface.
 */
export function instanceOfGetCurrentUser200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetCurrentUser200ResponseFromJSON(json: any): GetCurrentUser200Response {
    return GetCurrentUser200ResponseFromJSONTyped(json, false);
}

export function GetCurrentUser200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCurrentUser200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CurrentUserDetailFromJSON(json['data']),
    };
}

export function GetCurrentUser200ResponseToJSON(value?: GetCurrentUser200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CurrentUserDetailToJSON(value.data),
    };
}

